// extracted by mini-css-extract-plugin
export default {"button":"button-header_button__gE5G7","hidden":"button-header_hidden__Ay3Pt","none":"button-header_none__+Bd3A","text":"button-header_text__1pP0C","icon":"button-header_icon__QsQzj"};